<bitf-mat-search [apiCallStateName]="apiCallStateName"
  [apiRequestPartKey]="apiRequestPartKey"
  formKey="fullText"
  [hasCancelButton]="true"
  placeholder="{{'COMMON.LABEL.ADVANCED_SEARCH' | translate}}"
  [isInToolbar]="true"></bitf-mat-search>